import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "@/App.css";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Steps } from "@/components/Steps";
import { Partners } from "@/components/Partners";
import { Pricing } from "@/components/Pricing";
import { Team } from "@/components/Team";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { StickyCTA } from "@/components/StickyCTA";
import { AnalyticsPageViews } from "@/components/AnalyticsPageViews";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

const Landing = () => (
    <>
        <Nav />
        <main>
            <Hero />
            <Marquee />
            <Services />
            <Steps />
            <Partners />
            <Pricing />
            <Team />
            <Contact />
        </main>
        <Footer />
        <StickyCTA />
    </>
);

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
        let frame;
        const raf = (time) => {
            lenis.raf(time);
            frame = requestAnimationFrame(raf);
        };
        frame = requestAnimationFrame(raf);

        const onClick = (e) => {
            const anchor = e.target.closest('a[href^="#"]');
            if (!anchor) return;
            const target = document.querySelector(anchor.getAttribute("href"));
            if (target) {
                e.preventDefault();
                lenis.scrollTo(target, { offset: -72 });
            }
        };
        document.addEventListener("click", onClick);
        return () => {
            cancelAnimationFrame(frame);
            lenis.destroy();
            document.removeEventListener("click", onClick);
        };
    }, []);

    return (
        <div className="grain min-h-screen bg-cream font-sans text-charcoal">
            <BrowserRouter>
                <ScrollToTop />
                <AnalyticsPageViews />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="*" element={<Landing />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
